	
$(document).ready(function(){
$('.navbar-toggler').click(function(){
$('.navbar-toggler').toggleClass('showtoggle');
});	
});	
$(window).scroll(function() {    
    var scroll = $(window).scrollTop();

    if (scroll >= 30) {
        $(".header_sec").addClass("fixed");
    } else {
        $(".header_sec").removeClass("fixed");
    }
});

$(document).ready(function() {
    $('.client_sec .owl-carousel').owlCarousel({
      items: 3,
      loop: true,
      margin: 10,
      autoWidth:true,
      // navText: ['<i class="fa-solid fa-angle-left"></i>', '<i class="fa-solid fa-angle-right"></i>'],
      autoplay: true,
      slideTransition: "linear",
      autoplayTimeout: 0,
      smartSpeed: 3000,
      fluidSpeed: true,
      autoplayTimeout:3000,
      autoplayHoverPause:true,
      responsiveClass: true,
      nav: false,
      dots: false,
      responsive: {
        0:{
            items:2,
        },
        400:{
            items:3,
        },
        600:{
            items:3,
        },
        1000:{
            items:5,
        },
        1920 : {
            items: 8
        }
      }
    });
  });








$(document).ready(function() {
var owl = $('.banRow .owl-carousel');
  owl.owlCarousel({
    margin:0,
    dots: false,
    autoplay: false,
    nav: false,
    dotsEach: false,
    loop: false,
    responsive: {
      0: {	
        items: 1
      },
      1200: {
        items: 1
      }
    }
  });
});

$(document).ready(function() {
var owl = $('.productCaro .owl-carousel');
  owl.owlCarousel({
    margin:20,
    dots: false,
    stagePadding: 50,
    autoplay: true,
    nav: true,
    dotsEach: false,
    loop: true,
    responsive: {
      0: {	
        items: 1
      },
      400: {
        items: 2
      },
      900: {
        items: 3
      },
      1200: {
        items: 3,
        stagePadding: 80,
      }
    }
  });
});
$(document).ready(function() {
var owl = $('.spekerSec .owl-carousel');
  owl.owlCarousel({
    margin:0,
    dots: false,
    autoplay: false,
    nav: true,
    dotsEach: false,
    loop: true,
    responsive: {
      0: {	
        items: 1
      },
      1200: {
        items: 1
      }
    }
  });
});


//$(document).ready(function() {
 // var owl = $('.rotedCarocel .owl-carousel');

  // Initialize the carousel
 // owl.owlCarousel({
  //  margin: 0,
  //  dots: false,
  //  autoplay: false,
  //  nav: true,
  //  dotsEach: false,
  //  center: true,
  //  loop: true,
  //  responsive: {
   //   0: { items: 1 },
  //    400: { items: 3 },
  //    800: { items: 4 },
  //    900: { items: 5 },
 //     1200: { items: 5 }
 //   }
 // });

  // Function to update the classes
 // function updateClasses() {
 //   var current = owl.find('.owl-item.center').index();
 //   var items = owl.find('.owl-stage').children();

    // Remove all previous classes
  //  items.removeClass('before-item after-item before-item1 after-item1');

    // Add classes based on the current center item
  //  items.eq(current - 1).toggleClass('before-item');
  //  items.eq(current + 1).toggleClass('after-item');
  //  items.eq(current - 2).toggleClass('before-item1');
 //   items.eq(current + 2).toggleClass('after-item1');
 // }

  // Apply the classes initially after the carousel has initialized
//  updateClasses();

  // Listen for the changed event to update classes
 // owl.on('changed.owl.carousel', function() {
  //  updateClasses();
 // });
//});
$(document).ready(function() {
var owl = $('.abutTm .owl-carousel');
  owl.owlCarousel({
    margin:0,
    dots: false,
    autoplay: true,
    nav: false,
    dotsEach: false,
    stagePadding: 50,
    loop: true,
    responsive: {
      0: {	
        items: 1,
        stagePadding: 20,
      },
      500: {
        items: 2
      },
      800: {
        items: 3
      },
      900: {
        items: 4
      },
      1300: {
        items: 5
      }
    }
  });
 }); 

$(document).ready(function() {
var owl = $('.suprtprdBox .owl-carousel');
  owl.owlCarousel({
    margin:20,
    dots: false,
    autoplay: true,
    nav: false,
    dotsEach: false,
    loop: true,
    responsive: {
      0: {	
        items: 1
      },
      450: {
        items: 2
      },
      800: {
        items: 3
      },
      900: {
        items: 3
      },
      1300: {
        items: 4
      }
    }
  });
 }); 



$(document).ready(function() {
    // Owl Carousel setup
    var owl = $('.rotedCarocel .owl-carousel');
    owl.owlCarousel({
        margin: 0,
        dots: false,
        autoplay: false,
        nav: true,
        dotsEach: false,
        center: true,
        loop: true,
        responsive: {
            0: { items: 1 },
            500: { items: 3 },
            800: { items: 4 },
            900: { items: 5 },
            1200: { items: 5 }
        },
        onInitialized: function(event) {
            applyClassToItems(event); // Apply classes when the carousel first initializes
        }
    });

    // Reapply classes whenever the carousel position changes
    $('.rotedCarocel .owl-carousel').on('changed.owl.carousel', function(e) {
        applyClassToItems(e); // Call the same function on every position change
    });

    // Function to apply the 'before-item', 'after-item', 'before-item1', and 'after-item1' classes
    function applyClassToItems(e) {
        var current = e.item.index; // Get the current item index
        var items = $(e.target).find('.owl-stage').children(); // Get all carousel items
        
        // Ensure all classes are removed first to avoid duplication
        items.removeClass('before-item after-item before-item1 after-item1');

        // Apply classes to the neighboring items
        if (items.length > 1) {
            items.eq(e.relatedTarget.normalize(current - 1)).addClass('before-item');
            items.eq(e.relatedTarget.normalize(current + 1)).addClass('after-item');
        }
        
        if (items.length > 3) {
            items.eq(e.relatedTarget.normalize(current - 2)).addClass('before-item1');
            items.eq(e.relatedTarget.normalize(current + 2)).addClass('after-item1');
        }
    }

    // Clicking on an item in the carousel should navigate to that item
    $('.rotedCarocel .owl-item').on('click', function() {
        var clickedIndex = $(this).index();
        owl.trigger('to.owl.carousel', [clickedIndex, 300]);
    });

    // Click handler for .thb-widget-title
    $(".footItem .thb-widget-title").click(function(event) {
        event.preventDefault();
        // Toggle the 'current' class on the parent element when clicked
        $(this).parent().parent().toggleClass("current");
    });
});


$(document).ready(function() {
var owl = $('.productFetucaro.owl-carousel');
  owl.owlCarousel({
    margin:20,
    dots: false,
    stagePadding: 50,
    autoplay: true,
    nav: true,
    dotsEach: false,
    loop: true,
    responsive: {
      0: {	
        items: 1
      },
      400: {
        items: 1
      },
      500: {
        items: 2
      },
      900: {
        items: 3
      },
      1200: {
        items: 4,
        stagePadding: 80,
      }
    }
  });
});
